/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__customer-service-support-website-overview/src/__generated__/SupportWebsiteOverviewQuery$parameters.ts';
import newParameters from '@jira/servicedesk__customer-service-support-website-overview/src/__generated__/SupportWebsiteOverviewNewQuery$parameters.ts';
import type { SupportWebsiteOverviewQuery } from '@jira/servicedesk__customer-service-support-website-overview/src/__generated__/SupportWebsiteOverviewQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';

type HelpCenterSettingsSupportWebsiteOverviewAppEntryPointComponent = EntryPointComponent<
	{
		serviceHubDetailsQuery: SupportWebsiteOverviewQuery;
	},
	{},
	{},
	{} | null
>;

export const HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint: EntryPoint<
	HelpCenterSettingsSupportWebsiteOverviewAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsSupportWebsiteOverviewAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-support-website-overview-app" */ './HelpCenterSettingsSupportWebsiteOverviewApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			serviceHubDetailsQuery: {
				parameters: fg('csm-omni-channel-live-chat-in-widget') ? newParameters : parameters,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
